import React from 'react';

const TagDetailPage = () => {
  return <div>TagDetailPage</div>;
};

export default TagDetailPage;
